import React, { useState, useEffect } from 'react';
import './Testimonials.css';

const testimonialData = [
  {
    quote: "Genix has revolutionized my practice. The AI transcription is incredibly accurate, and it saves me hours of documentation time every day. I can focus more on patient care now.",
    author: "Dr. Rajeev S",
    role: "Senior Cardiologist",
    location: "Apollo Hospitals, Mumbai",
    image: "/images/doctor1.png"
  },
  {
    quote: "The ambient voice recognition is a game-changer. I can focus entirely on my patients while Genix handles all the documentation seamlessly. The accuracy is remarkable.",
    author: "Dr. Sarah Patel",
    role: "Pediatric Specialist",
    location: "Fortis Healthcare, Delhi",
    image: "/images/doctor1.png"
  },
  {
    quote: "What impresses me most is how Genix understands medical terminology perfectly. It's like having a trained medical scribe always by my side. Highly recommended.",
    author: "Dr. Arun Kumar",
    role: "Orthopedic Surgeon",
    location: "AIIMS, New Delhi",
    image: "/images/doctor1.png"
  },
  {
    quote: "The integration was smooth, and the learning curve was minimal. Now I can't imagine practicing without Genix. It has transformed my daily workflow completely.",
    author: "Dr. Priya Mehta",
    role: "General Physician",
    location: "Max Healthcare, Bangalore",
    image: "/images/doctor1.png"
  }
];

const Testimonials = ({ customTitle }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const [isMobile, setIsMobile] = useState(() => typeof window !== 'undefined' ? window.innerWidth <= 570 : false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 570);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Create groups of 3 testimonials, repeating data as needed
  const createTestimonialGroups = () => {
    const groups = [];
    const totalGroups = 3; // We want 3 groups for infinite scroll effect
    
    for (let i = 0; i < totalGroups; i++) {
      const group = [];
      for (let j = 0; j < 3; j++) {
        const index = j % testimonialData.length;
        group.push(testimonialData[index]);
      }
      groups.push(group);
    }
    return groups;
  };

  const testimonialGroups = createTestimonialGroups();

  // Mobile ke liye slide width
  const slideWidth = isMobile ? 80 : 100; // 80vw for mobile, 100% for desktop group
  const totalSlides = isMobile ? testimonialData.length : testimonialGroups.length;

  const nextSlide = () => {
    setCurrentSlide((prev) => 
      prev === totalSlides - 1 ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => 
      prev === 0 ? totalSlides - 1 : prev - 1
    );
  };

  // Auto advance slides
  useEffect(() => {
    const timer = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(timer);
  }, [isMobile, totalSlides]);

  // Touch handlers for mobile
  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe) {
      nextSlide();
    } else if (isRightSwipe) {
      prevSlide();
    }
  };

  // Mobile ke liye flat group bana lo
  let renderGroups = testimonialGroups;
  if (isMobile) {
    // Sabhi testimonials ko ek hi group me daal do
    renderGroups = [testimonialData];
  }

  return (
    <section className="testimonials-section">
      <div className="testimonials-container">
        {/* Left Section - Header */}
        <div className="testimonials-header">
          <h2>
            {customTitle || (
              <>
                Trusted by
                <span>Healthcare Professionals</span>
              </>
            )}
          </h2>
        </div>

        {/* Right Section - Carousel */}
        <div className="testimonials-carousel">
          <div className="testimonials-track-container">
            <div 
              className="testimonials-track" 
              style={{ 
                transform: isMobile
                  ? `translateX(-${currentSlide * slideWidth}vw)`
                  : `translateX(-${currentSlide * 100}%)`,
              }}
              onTouchStart={onTouchStart}
              onTouchMove={onTouchMove}
              onTouchEnd={onTouchEnd}
            >
              {isMobile
                ? testimonialData.map((testimonial, index) => (
                    <div key={index} className="testimonial-card">
                      <p className="quote">{testimonial.quote}</p>
                      <div className="author-info">
                        <img 
                          src={testimonial.image} 
                          alt={testimonial.author} 
                          className="author-image"
                        />
                        <div className="author-details">
                          <h4>{testimonial.author}</h4>
                          <p>{testimonial.role} • {testimonial.location}</p>
                        </div>
                      </div>
                    </div>
                  ))
                : renderGroups.map((group, groupIndex) => (
                    <div key={groupIndex} className="testimonial-group">
                      {group.map((testimonial, index) => (
                        <div 
                          key={`${groupIndex}-${index}`} 
                          className="testimonial-card"
                        >
                          <p className="quote">{testimonial.quote}</p>
                          <div className="author-info">
                            <img 
                              src={testimonial.image} 
                              alt={testimonial.author} 
                              className="author-image"
                            />
                            <div className="author-details">
                              <h4>{testimonial.author}</h4>
                              <p>{testimonial.role} • {testimonial.location}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ))}
            </div>
          </div>

          <div className="carousel-controls">
            {testimonialGroups.map((_, index) => (
              <button
                key={index}
                className={`dot ${currentSlide === index ? 'active' : ''}`}
                onClick={() => setCurrentSlide(index)}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials; 